;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ApprovalListController', ApprovalListController)

  /* @ngInject */
  function ApprovalListController ($scope, $rootScope, $q, $translate, $state, $timeout, $stateParams, $location, ArtsService, AdminService, GroupService, Utils, CONSTANTS, ModalService, ToastService, TagsService, FormatsService, AssetPreviewService) {
    const getApprovalDialogController = () => $q.when(import('../../dialogs/approval/approval-dialog.controller'))

    $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
    $scope.approvalTabs = [
      { label: $translate.instant('waitingApproval'), value: 'PENDING_APPROVAL' },
      { label: $translate.instant('adjustmentsNeeded'), value: 'PENDING_REWORK' },
      { label: $translate.instant('approved'), value: 'APPROVED' },
      { label: $translate.instant('rejectedTab'), value: 'REJECTED' }
    ]

    $scope.listHeader = [
      { label: $translate.instant('title'), value: 'name' },
      { label: $translate.instant('product'), value: 'productTitle' },
      { label: $translate.instant('workflow.requester'), value: 'username' },
      { label: $translate.instant('date'), value: 'lastApprovalDate' },
      { label: $translate.instant('status'), value: 'status' }
    ]

    $scope.selectedOrder = {
      name: 'lastApprovalDate',
      order: 'DESC'
    }

    $scope.companyFeatures = {
      groupSegmentation: {
        access: false,
        data: {}
      },
      artsCustomization: {
        access: true
      }
    }

    $scope.groups = []
    $scope.users = []

    $scope.top = 10
    $scope.tokensCount = 3
    $scope.loading = false

    $scope.searchTerm = ''
    $scope.userIsSelected = true
    $scope.dropdownUsers = []
    $scope.dropdownGroups = []
    $scope.products = []
    $scope.selectedFilters = {
      statusFilter: 'PENDING_APPROVAL',
      userId: '',
      groupId: '',
      initialDate: '',
      endDate: '',
      productId: '',
      isArchived: false
    }

    $scope.pageTitle = ''
    $scope.location = 'materialsApproval'
    $scope.isOpening = false

    let thumbTop

    const api = {
      getApprovalDialogController,
      _skipPagingTo,
      _handleCompanyFeatures,
      _successGetApprovalArts,
      _successGetUsers,
      _successGetGroups,
      _successGetProducts,
      _openOldApprovalDialog,
      _calcCardsPerLine,
      _initializeGroupDropdown,
      _initializeUserDropdown,
      _selectTabFromParam,
      _keepOnSamePage,
      _checkIfPageExists,
      _onFilter,
      _initHeader,
      _onSearch,
      _showApprovalModal,
      _getPreviewAssets
    }
    this.getApi = () => api

    activate()

    function activate () {
      api._handleCompanyFeatures().then(() => {
        api._initHeader()
      })

      if ($rootScope.isDesktop) {
        $scope.visualization = 'thumb'
        api._calcCardsPerLine()
      } else {
        $scope.visualization = 'list'
        $('.header-mobile-dropdown').dropdown()
        $('.mobile-sort-dropdown').dropdown()
        $scope.listHeader.pop()
      }

      if ($stateParams.art) {
        ArtsService.getArtDetailById($stateParams.art).then(art => {
          $scope.openApprovalDialog(art)
        })
      }

      if ($stateParams.selectedTab) {
        api._selectTabFromParam($stateParams.selectedTab)
      } else {
        $scope.selectedTab = $scope.approvalTabs[0]
      }

      $scope.loading = true
      api._keepOnSamePage($stateParams)
      GroupService.getGroups(null, null, null, false).then(api._successGetGroups)
      AdminService.getUsersSimplified().then(api._successGetUsers)
      AdminService.getCustomerProducts().then(api._successGetProducts)

      $timeout(() => {
        $scope.$apply(() => {
          $scope.datePickersSettings = {
            minStartDate: moment($rootScope.oUserCompany.createdAt),
            maxStartDate: moment(),
            minEndDate: moment($rootScope.oUserCompany.createdAt),
            maxEndDate: moment()
          }
        })
      }, 200, false)
    }

    $scope.onSearchApprovals = api._onSearch

    const deregisterReloadApprovalList = $rootScope.$on('reload-approval-list', () => {
      if ($stateParams.page && $scope.arts.length > 1) {
        api._skipPagingTo($stateParams.page, true)
      } else {
        api._skipPagingTo(0)
      }
    })

    const deregisterReopenVideoPreview = $rootScope.$on('arts.reopenVideoPreviewApproval', (ev, template) => {
      $scope.openApprovalDialog(template)
    })

    $scope.$on('$destroy', () => {
      deregisterReloadApprovalList()
      deregisterReopenVideoPreview()
    })

    $scope.skipPagingTo = api._skipPagingTo

    $scope.changeVisualization = function (visualization) {
      if ($rootScope.isDesktop) {
        if (visualization === 'list') {
          $scope.top = 10
        } else {
          $scope.top = thumbTop
        }
      }
      $scope.visualization = visualization
      api._skipPagingTo(0)
    }

    $scope.clearSearchTerm = function () {
      $scope.searchTerm = ''
      api._skipPagingTo(0)
    }

    $scope.openApprovalDialog = function (art) {
      if ($scope.isOpening) return
      $scope.isOpening = true

      api._showApprovalModal(art).finally(() => {
        $scope.isOpening = false
      })
    }

    $scope.sortListClick = function (field) {
      if (!$rootScope.isDesktop) {
        $scope.selectedOrder.name = field
        $scope.selectedOrder.order = 'DESC'
      } else {
        if ($scope.selectedOrder.name === field) {
          if ($scope.selectedOrder.order === 'ASC') {
            $scope.selectedOrder.order = 'DESC'
          } else if ($scope.selectedOrder.order === 'DESC') {
            $scope.selectedOrder.order = ''
            $scope.selectedOrder.name = ''
          }
        } else {
          $scope.selectedOrder.name = field
          $scope.selectedOrder.order = 'ASC'
        }
      }
      api._skipPagingTo(0)
    }

    $scope.clearFilters = function () {
      $scope.selectedFilters = { productId: '', userId: '', initialDate: '', endDate: '', groupId: '', statusFilter: $scope.selectedTab.value }
      $scope.datePickersSettings.minStartDate = moment($rootScope.oUserCompany.createdAt)
      $scope.datePickersSettings.minEndDate = moment($rootScope.oUserCompany.createdAt)
      $scope.datePickersSettings.maxStartDate = moment()
      $scope.datePickersSettings.maxEndDate = moment()
      $timeout(() => {
        $('.filter-approval-by-user').dropdown('clear')
        $('.filter-approval-by-group').dropdown('clear')
        $('.filter-approval-by-product').dropdown('clear')
      }, 200, false)

      api._skipPagingTo(0)
    }

    $scope.changeSelectedTab = function (tab) {
      if ($scope.selectedTab === tab) {
        return
      }

      $scope.selectedFilters.statusFilter = tab.value
      $scope.selectedTab = tab
      api._skipPagingTo(0)
    }

    $scope.getThumbUrl = function (art) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_THUMBNAIL_ID, [art.id])
      url += '?' + art.updatedAt
      return url
    }

    $scope.onSelectInitialDate = function () {
      if ($scope.selectedFilters.initialDate) {
        $scope.datePickersSettings.minEndDate = moment($scope.selectedFilters.initialDate)
        api._skipPagingTo(0)
      }
    }

    $scope.onSelectEndDate = function () {
      if ($scope.selectedFilters.endDate) {
        $scope.datePickersSettings.maxStartDate = moment($scope.selectedFilters.endDate)
        api._skipPagingTo(0)
      }
    }

    $scope.resetOneFilter = function (filter) {
      $scope.selectedFilters[filter] = ''
      api._skipPagingTo(0)
    }

    $scope.selectUserGroup = (selected) => {
      if (selected === 'group') {
        $scope.userIsSelected = false
      } else {
        $scope.userIsSelected = true
      }

      $timeout(() => {
        api._initializeGroupDropdown()
        api._initializeUserDropdown()
      }, 500, false)

      $timeout(() => {
        $('.filter-approval-by-user').dropdown('clear')
        $('.filter-approval-by-group').dropdown('clear')
      }, 0, false)
    }

    function _handleCompanyFeatures () {
      return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
        $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
        $scope.companyFeatures.groupSegmentation = {
          access: !!features['ARTS.GROUPS_SEGMENTATION'],
          data: {
            featureName: $translate.instant('billingFeatures.artsGroupsSegmentation'),
            featureSlug: 'ARTS.GROUPS_SEGMENTATION'
          }
        }
      })
    }

    function _skipPagingTo (index, fromParams) {
      $scope.loading = true

      let pageToken = Number(index)
      const selectedTab = $scope.selectedTab ? $scope.selectedTab.value : 'PENDING_APPROVAL'

      $scope.selectedFilters.statusFilter = selectedTab

      if (!fromParams || !pageToken) {
        pageToken = isNaN(pageToken) ? 1 : pageToken + 1
      }

      if (pageToken < 1) {
        pageToken = 1
      }

      $scope.selectedFilters.statusFilter = selectedTab
      $scope.currentPage = pageToken
      $scope.indexToken = pageToken - 1

      const search = $scope.searchTerm || null
      const page = pageToken !== 1 ? pageToken : null

      $location.search({ ...$state.params, search, selectedTab, page })

      const skip = (pageToken - 1) * $scope.top

      ArtsService.getArtsApprovals($scope.top, skip, $scope.selectedFilters, $scope.selectedOrder, $scope.searchTerm).then(api._successGetApprovalArts)
    }

    function _successGetApprovalArts (arts) {
      $scope.arts = arts.d.results
      $scope.artsCount = arts.d.__count

      api._checkIfPageExists($scope.artsCount, $scope.top)

      $scope.arts.forEach(art => {
        art.user = {
          name: art.username,
          profileImageId: art.userPicture,
          id: art.userId,
          userStatus: art.userStatus,
          removed: art.removed
        }
      })

      $scope.loading = false
    }

    function _successGetGroups (data) {
      $scope.groups = data.d.results.map(group => {
        return {
          label: group.name,
          value: group.id
        }
      })

      $timeout(api._initializeGroupDropdown, 500, false)
    }

    function _initializeGroupDropdown () {
      $('.filter-approval-by-group').dropdown({
        clearable: true,
        match: 'text',
        allowAdditions: false,
        forceSelection: false,
        message: {
          noResults: $translate.instant('noResults')
        },
        onChange: function (value) {
          $scope.selectedFilters.groupId = value
          api._skipPagingTo(0)
        }
      })
    }

    function _initializeUserDropdown () {
      $('.filter-approval-by-user').dropdown({
        clearable: true,
        match: 'text',
        allowAdditions: false,
        forceSelection: false,
        direction: 'upward',
        message: {
          noResults: $translate.instant('noResults')
        },
        onChange: function (value) {
          $scope.selectedFilters.userId = value
          api._skipPagingTo(0)
        }
      })
    }

    function _successGetUsers (data) {
      const users = (data && data.rows) || []
      $scope.users = users.map(group => {
        return {
          label: group.name,
          value: group.id
        }
      })

      $timeout(() => {
        api._initializeUserDropdown()
      }, 500, false)
    }

    function _successGetProducts (data) {
      $scope.products = data.rows

      $timeout(() => {
        jQuery('.filter-approval-by-product').dropdown({
          clearable: true,
          match: 'text',
          allowAdditions: false,
          forceSelection: false,
          message: {
            noResults: $translate.instant('noResults')
          },
          onChange: function (value) {
            $scope.selectedFilters.productId = value
            api._skipPagingTo(0)
          }
        })
      }, 500, false)
    }

    function _openOldApprovalDialog (art) {
      api.getApprovalDialogController().then(({ ApprovalDialogController }) => {
        ModalService.showModal({
          templateId: 'approvalDialog.html',
          templateUrl: '/arts/dialogs/approval/approval-dialog.html?$$REVISION$$',
          observeChanges: true,
          destroyable: true,
          controller: ApprovalDialogController,
          data: {
            id: art.id
          }
        }).then(() => {
          $location.search({ ...$stateParams, art: null, selectedTab: $stateParams.selectedTab })
        })
      })
    }

    function _calcCardsPerLine () {
      const container = document.querySelector('.thumbnail-visualization')
      const computedStyle = window.getComputedStyle(container)
      const width = Number.parseInt(computedStyle.width) - 64
      const cardsPerLine = Math.floor(width / 286)

      thumbTop = cardsPerLine * 3
      $scope.top = thumbTop
    }

    function _selectTabFromParam (selectedTab) {
      const hasTab = $scope.approvalTabs.filter(tab => {
        return tab.value === selectedTab
      })

      if (!hasTab.length) {
        $scope.selectedTab = $scope.approvalTabs[0]
        $location.search({ ...$stateParams, selectedTab: null })
        return
      }

      $scope.selectedFilters.statusFilter = selectedTab
      $scope.selectedTab = { value: selectedTab }

      api._skipPagingTo(0)
    }

    function _keepOnSamePage (stateParams) {
      if (stateParams.page) {
        api._skipPagingTo(stateParams.page, true)
      } else {
        $scope.searchTerm = stateParams.search || ''
        api._skipPagingTo(0)
      }
    }

    function _checkIfPageExists (count, top) {
      if (!count) {
        return
      }

      const paginationSize = Math.ceil(count / top)

      if ($scope.currentPage > paginationSize) {
        api._skipPagingTo(1, true)
        ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
      }
    }

    function _onSearch (term) {
      $scope.searchTerm = term
      $scope.visualization = 'list'
      api._skipPagingTo(0)

      if (term === '' || term === null) {
        if ($rootScope.isDesktop) {
          $scope.visualization = 'thumb'
        }
      }
    }

    function _onFilter (filters) {
      $scope.selectedFilters = {
        ...$scope.selectedFilters,
        ...filters
      }
      api._skipPagingTo($state.params)
    }

    function _getPreviewAssets () {
      return Promise.resolve({
        assets: $scope.arts,
        count: $scope.arts.length
      })
    }

    function _showApprovalModal (art) {
      return ArtsService.getArtPins(art.id).then((pins) => {
        // Art preview release date, any pin earlier from this date will not be positioned correctly.
        const oldPinsDate = new Date('2024-03-10')
        const oldPins = pins.filter(pin => new Date(pin.createdAt) <= oldPinsDate)

        if (oldPins.length) {
          api._openOldApprovalDialog(art)
          return
        }

        AssetPreviewService.openAssetPreview({
          asset: art,
          getPreviewAssets: api._getPreviewAssets,
          location: $scope.location
        })
      })
    }

    function _initHeader () {
      $scope.pageTitle = $translate.instant('dashboard.approvals')

      const exhibitDefaultValue = {
        label: $translate.instant('actives'),
        value: false,
        icon: 'success',
        active: true,
        disabled: false
      }

      const filters = [
        {
          name: 'isArchived',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: exhibitDefaultValue,
          props: {
            label: $translate.instant('exhibit'),
            multiple: false,
            switchMode: true,
            udsDisabled: false,
            options: [
              exhibitDefaultValue,
              {
                label: $translate.instant('archivedPlural'),
                value: true,
                icon: 'archive',
                active: false,
                disabled: false
              }
            ]
          }
        },
        {
          name: 'customizationLevel',
          type: 'FILTER_BUTTON_SELECT',
          grouped: false,
          defaultValue: null,
          props: {
            label: $translate.instant('customizationLevel'),
            multiple: false,
            switchMode: false,
            udsDisabled: false,
            options: [
              {
                label: $translate.instant('permissionFree'),
                value: 'FREE_STYLE',
                icon: 'unlock',
                active: false,
                disabled: false
              },
              {
                label: $translate.instant('permissionRestricted'),
                value: 'RESTRICTED',
                icon: 'lock',
                active: false,
                disabled: false
              },
              {
                label: $translate.instant('customizable'),
                value: 'CUSTOMIZABLE',
                icon: 'lock-filled',
                active: false,
                disabled: false
              }
            ]
          }
        },
        {
          name: 'artTagIds',
          type: 'INPUT_MULTISELECT',
          grouped: false,
          defaultValue: [],
          props: {
            label: $translate.instant('filterByTags'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            loadButtonLabel: '',
            type: 'tag',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: (name, top, skip) => TagsService.getTags({ name, top, skip })
        },
        {
          name: 'formatId',
          type: 'INPUT_SELECT',
          grouped: true,
          defaultValue: null,
          props: {
            label: $translate.instant('product'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'text',
            hasMoreOptions: false,
            udsDisabled: false,
            pricing: false,
            pricingTooltip: '',
            pricingTooltipPosition: 'top',
            options: []
          },
          loadData: (search, top, skip) => FormatsService.getFormats({ search, top, skip })
        },
        {
          name: 'groupId',
          type: 'INPUT_SELECT',
          grouped: true,
          defaultValue: null,
          props: {
            label: $translate.instant('userGroup'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'text',
            hasMoreOptions: false,
            udsDisabled: false,
            pricing: false,
            pricingTooltip: '',
            pricingTooltipPosition: 'top',
            options: []
          },
          loadData: (searchTerm, top, skip) => GroupService.getGroups(top, skip, { searchTerm })
        },
        {
          name: 'ownerId',
          type: 'INPUT_MULTISELECT',
          grouped: false,
          defaultValue: [],
          props: {
            label: $translate.instant('users'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'user',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: (search, top, skip) => AdminService.filterUsers(top, skip, { search })
        },
        {
          name: 'createdAt',
          type: 'DATE_PICKER',
          grouped: true,
          defaultValue: '',
          props: {
            locale: $rootScope.oUser.locale,
            label: $translate.instant('creationDate'),
            firstDayOfWeek: '1',
            direction: 'right'
          }
        },
        {
          name: 'templateExpiration',
          type: 'DATE_PICKER',
          grouped: true,
          defaultValue: '',
          props: {
            locale: $rootScope.oUser.locale,
            label: $translate.instant('expiration'),
            firstDayOfWeek: '1',
            direction: 'right'
          }
        }
      ]

      $scope.headerToolbar = {
        search: {
          filters,
          onFilter: api._onFilter,
          onSearch: api._onSearch
        }
      }
    }
  }
})()
